export default __webpack_public_path__ + "static/media/banner_testbank.81148aab.jpg";